import { render, staticRenderFns } from "./SearchFiltersFooter.vue?vue&type=template&id=94980a1c&scoped=true"
import script from "./SearchFiltersFooter.vue?vue&type=script&lang=js"
export * from "./SearchFiltersFooter.vue?vue&type=script&lang=js"
import style0 from "./SearchFiltersFooter.vue?vue&type=style&index=0&id=94980a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94980a1c",
  null
  
)

export default component.exports